import { Link } from 'react-router-dom';
import { Container } from '@/components/ui/container';
import { Logo } from '@/components/brand/logo';
import { cn, focusRing } from '@/lib/utils';

const NAV_LINKS = [
  { to: '/services', label: 'Solutions' },
  { to: '/philosophy', label: 'Philosophy' },
  { to: '/process', label: 'Process' },
  { to: '/insights', label: 'Insights' },
] as const;

const LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/privacy', label: 'Terms' },
] as const;

const EXTERNAL_LINKS = [
  { href: 'https://www.linkedin.com/company/humaine', label: 'LinkedIn' },
  { href: 'https://twitter.com/humaine_ai', label: 'Twitter' },
  { href: 'https://www.instagram.com/humaine_ai', label: 'Instagram' },
] as const;

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t border-outline-variant/50 bg-surface-container-low">
      <Container size="xl" className="py-16">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-xs">
            <Link
              to="/"
              aria-label="HumAIne home"
              className={cn('inline-flex rounded-md', focusRing)}
            >
              <Logo />
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-on-surface-variant">
              Human-first outcomes, powered by AI.
            </p>
          </div>

          <div className="flex flex-wrap gap-8 md:gap-12">
            <div>
              <h2 className="text-xs font-semibold uppercase tracking-widest text-on-surface-variant">
                Navigate
              </h2>
              <ul className="mt-4 space-y-2">
                {NAV_LINKS.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className={cn(
                        'text-sm text-on-surface-variant transition-all hover:text-on-tertiary-container hover:bg-tertiary-fixed-dim/10 px-2 py-0.5 -mx-2 rounded-md',
                        focusRing,
                      )}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-xs font-semibold uppercase tracking-widest text-on-surface-variant">
                Legal
              </h2>
              <ul className="mt-4 space-y-2">
                {LEGAL_LINKS.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className={cn(
                        'text-sm text-on-surface-variant transition-all hover:text-on-tertiary-container hover:bg-tertiary-fixed-dim/10 px-2 py-0.5 -mx-2 rounded-md',
                        focusRing,
                      )}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-xs font-semibold uppercase tracking-widest text-on-surface-variant">
                Connect
              </h2>
              <ul className="mt-4 space-y-2">
                {EXTERNAL_LINKS.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={cn(
                        'text-sm text-on-surface-variant transition-all hover:text-on-tertiary-container hover:bg-tertiary-fixed-dim/10 px-2 py-0.5 -mx-2 rounded-md',
                        focusRing,
                      )}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-outline-variant/30 pt-6 text-xs text-on-surface-variant sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {year} HumAIne. Human-First AI.</p>
          <p>South Africa &middot; Remote-first</p>
        </div>
      </Container>
    </footer>
  );
}
